export interface AspenAuth0Config {
    auth0Domain: string
    auth0ClientId: string
    auth0AudienceDomain: string
    auth0AspenScopes: string
}

/**
 * APP-34 light option ("Send" layer): choose which Auth0 tenant/audience the
 * dashboard logs in against.
 *
 * Default (flag unset / not 'true') = the aspen tenant — unchanged behavior.
 * When REACT_APP_ENABLE_PLATFORM_AUDIENCE === 'true', log in against the platform
 * tenant so the dashboard obtains a platform-audience token that authorizes both
 * Origin greenlight and aspen APIs (one token). Fail safe: any value other than
 * the literal 'true' keeps the aspen tenant.
 */
export function resolveAspenAuth0Config(env: Record<string, string | undefined> = process.env): AspenAuth0Config {
    if (env.REACT_APP_ENABLE_PLATFORM_AUDIENCE === 'true') {
        return {
            auth0Domain: env.REACT_APP_PLATFORM_AUTH0_DOMAIN as string,
            auth0ClientId: env.REACT_APP_PLATFORM_AUTH0_CLIENT_ID as string,
            auth0AudienceDomain: env.REACT_APP_PLATFORM_AUDIENCE as string,
            auth0AspenScopes: env.REACT_APP_PLATFORM_SCOPES as string
        }
    }
    return {
        auth0Domain: env.REACT_APP_AUTH0_DOMAIN as string,
        auth0ClientId: env.REACT_APP_AUTH0_CLIENT_ID as string,
        auth0AudienceDomain: env.REACT_APP_AUTH0_AUDIENCE_DOMAIN as string,
        auth0AspenScopes: env.REACT_APP_AUTH0_ASPEN_SCOPES as string
    }
}

export const aspenAuth0Config: AspenAuth0Config = resolveAspenAuth0Config()
